export async function bootstrapCurrentClientHydration() {
    const litHydrateSupportInstalled = import('@lit-labs/ssr-client/lit-element-hydrate-support.js');
    try {
        // Check if we require the template shadow root polyfill.
        // https://web.dev/articles/declarative-shadow-dom#feature_detection_and_browser_support
        if (!Object.hasOwn(HTMLTemplateElement.prototype, 'shadowRootMode')) {
            // Fetch the template shadow root polyfill.
            const { hydrateShadowRoots } = await import('@webcomponents/template-shadowroot/template-shadowroot.js');
            // Apply the polyfill. This is a one-shot operation, so it is important
            // it happens after all HTML has been parsed.
            hydrateShadowRoots(document.body);
            // At this point, browsers without native declarative shadow DOM
            // support can paint the initial state of your components!
            document.body.removeAttribute('dsd-pending');
        }
    }
    catch {
        // eslint-disable-next-line no-console
        console.error('[CRNT SSR MIDDLEWARE CLIENT] Failed to polyfill Declarative Shadow DOM');
    }
    await litHydrateSupportInstalled;
}
